import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';
import Link from 'components/Link';

const ResourcesList = props => {
  const className = classnames('ResourcesList', {
    'is-inner': props.showsAll
  });

  return (
    <div className={className}>
      {(() => {
        if(!props.showsAll) {
          return (
            <div className="head">
              <p className="link-see-all"><Link to="/chat-resources">{__('members.chat.resources.viewAll')}</Link></p>
              <h4>{__('members.chat.resources.title')}</h4>
              <p>{__('members.chat.resources.subtitle')}</p>
            </div>
          );
        }
      })()}

      <div className="list">
        {props.children}
      </div>
    </div>
  );
};

ResourcesList.propTypes = {
  showsAll: PropTypes.bool,
  children: PropTypes.array
};

export default ResourcesList;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ResourcesList/index.js
 **/